import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { "format-key": "0" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_localize = _resolveComponent("localize")
  const _component_modal_box = _resolveComponent("modal-box")

  return ($props.isVisible)
    ? (_openBlock(), _createBlock(_component_modal_box, {
        key: 0,
        "is-visible": $props.isVisible,
        title: _ctx.Resources.ProjectHome.ChangeDisplayCurrencyTitle,
        icon: "sync"
      }, {
        actions: _withCtx(() => [
          _createElementVNode("a", {
            href: "#",
            class: "gfu-link gfu-link--accent",
            onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => ($options.onCancel && $options.onCancel(...args)), ["prevent"])),
            "data-qa": "modal-button:cancel"
          }, _toDisplayString(_ctx.Resources.Common.ModalCancelButton), 1 /* TEXT */),
          _createElementVNode("button", {
            type: "button",
            class: "gfu-btn gfu-btn--accent gfu-btn--compact gfu-btn--soft gfu-btn--wide _ml-3",
            onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => ($options.onAccept && $options.onAccept(...args)), ["prevent"])),
            "data-qa": "modal-button:Continue"
          }, _toDisplayString(_ctx.Resources.Common.ModalContinueButton), 1 /* TEXT */)
        ]),
        default: _withCtx(() => [
          _createElementVNode("p", null, [
            _createVNode(_component_localize, {
              resource: _ctx.Resources.ProjectHome.ChangeDisplayCurrencyParagraph
            }, {
              default: _withCtx(() => [
                _createElementVNode("strong", _hoisted_1, _toDisplayString($props.currency.symbol), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["resource"])
          ]),
          _createElementVNode("p", null, _toDisplayString(_ctx.Resources.ProjectHome.ChangeDisplayCurrencyNote), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["is-visible", "title"]))
    : _createCommentVNode("v-if", true)
}